// Small round doctor photo for admin tables; initials fallback when the
// pledge has no photo. Works with both inline base64 and CDN URLs.
export function DoctorPhoto({ pledge, size = "w-9 h-9" }) {
  const initials = (pledge.name || "")
    .replace(/^Dr\.?\s*/i, "")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((s) => s[0])
    .join("")
    .toUpperCase() || "DR";
  return pledge.photo ? (
    <img src={pledge.photo} alt={pledge.name} className={`${size} rounded-full object-cover ring-1 ring-slate-200`} />
  ) : (
    <span className={`grid place-items-center ${size} rounded-full bg-gradient-to-br from-[#0056D2] to-[#138808] text-white text-[10px] font-display font-bold`}>
      {initials}
    </span>
  );
}
